/* eslint-disable */
var riot = require('riot');
riot.tag('pc-helpfind', '<div class="wrapper"> <helpfind-form if="{ !helpfindok }"></helpfind-form> <helpfind-ok if="{ helpfindok }"></helpfind-ok> </div>', 'pc-helpfind { display: block; width: 100%; height: 480px; min-width: 1180px; background-position: center; background-size: cover; } pc-helpfind > .wrapper { width: 1180px; height: 100%; margin: 0 auto; position: relative; }', function(opts) {
    var that = this;
    var s = this.root.style;
    s.backgroundColor = opts.bgcolor? opts.bgcolor: '#ff0';
    s.backgroundImage = 'url(' + (opts.bgimg? opts.bgimg: '//placehold.it/1688x480') + ')';
    this.helpfindok = false;
    riot.route(function (collection, id, action) {
        if(collection == "helpfindsubmitok") {
            that.helpfindok = true;
            that.update();
        } else if (collection == "alert") {
            alert(id);
            riot.route('/');
        } else if (collection == "reinput") {
            that.helpfindok = false;
            that.update();
        }
    })
    
});
riot.tag('helpfind-ok', '<div class="helpfind-success"> <div class="success-icon"></div> <h1>您的找车申请已经提交成功</h1> <div class="success-jump"><span id="time-num">{ time }</span>秒钟后跳转到首页</div> <div class="success-link"><a href="/">立即去首页</a></div> <div class="success-explain"> <p>{ parent.opts.shopname }的工作人员将会尽快联系您</p> <p>感谢您对{ parent.opts.shopname }的支持！</p> </div> </div>', 'helpfind-ok { display: block; background: #fff; width: 310px; height: 260px; padding: 30px; position: absolute; right: 50px; top: 60px; font-size: 12px; } helpfind-ok .helpfind-success { width: 100%; height: 100%; text-align: center; } helpfind-ok .helpfind-success .success-icon { margin-top: 20px; width: 100%; height: 52px; background: url("//assets.souche.com/assets/images/sellcar/success.png") no-repeat scroll center center transparent; } helpfind-ok .helpfind-success h1 { font-weight: normal; } helpfind-ok .helpfind-success .success-explain{ border: 1px solid #D1D1D1; border-radius: 5px; height: 40px; background-color: #F9F9F9; padding: 20px; margin-top: 30px; margin-left: 5px; margin-right: 5px; } helpfind-ok .helpfind-success .success-explain p { line-height: 20px; margin: 0; }', function(opts) {
    var that = this;
    that.time = 5;
    riot.route(function (collection, id, action) {
        if(collection == "helpfindsubmitok") {
            setTimeout(function () {
                if (--that.time <= 0) {
                    riot.route('reinput');
                } else {
                    riot.route(collection + '/' + that.time);
                }
                that.update();
            }, 1000); 
        }
    });
    
});
riot.tag('helpfind-form', '<div class="title"> 帮我找车 </div> <div class="body"> <helpfind-carmodel class="mb10"></helpfind-carmodel> <helpfind-price class="mb10"></helpfind-price> <helpfind-yearandmileage class="mb10"></helpfind-yearandmileage> <helpfind-description class="mb10"></helpfind-description> <helpfind-shop class="mb10"></helpfind-shop> <helpfind-cellphone class="mb10"></helpfind-cellphone> <helpfind-submit></helpfind-submit> </div>', 'helpfind-form { display: block; background: #fff; width: 390px; height: 385px; box-sizing: border-box; padding: 20px 36px 0 44px; position: absolute; right: 45px; top: 45px; } helpfind-form > .title { font-size: 22px; padding-bottom: 18px; font-family: \'Microsoft YaHei\'; color: #333; } helpfind-form > .body .mb10 { margin-bottom: 10px; }', function(opts) {

});
riot.tag('helpfind-shop', '<div class="value" id="value"> { showvalue } </div> <div class="selectbg" if="{ showselect }" id="selectbg"></div> <div class="select" if="{ showselect }"> <div class="city select-child"> <div class="title">请选择城市</div> <div class="body"> <div class="option" each="{ k, v in imDataCity }" onclick="{ parent.doSelectCity }" data-city="{ k }">{ k }</div> </div> </div> <div class="shop select-child"> <div class="title">请选择店铺</div> <div class="body" if="{ city }"> <div class="option" each="{ imDataShop }" onclick="{ parent.doSelectShop }" data-code="{ code }" data-shop="{ nickName }">{ nickName }</div> </div> <div class="body" if="{ !city }"> <div class="option">请先选择城市</div> </div> </div> </div> <label>*</label>', 'helpfind-shop { display: block; width: 100%; height: 32px; border: solid #ddd 1px; position: relative; font-size: 12px; box-sizing: border-box; } helpfind-shop .value { width: 300px; height: 100%; line-height: 30px; cursor: pointer; color: #999; padding-left: 10px; } helpfind-shop .selectbg { position: fixed; width: 100%; height: 100%; top: 0; left: 0; background: rgba(0,0,0,0.1); } helpfind-shop .select { box-sizing: border-box; width: 100%; height: 200px; border: #FF5517 solid 2px; position: absolute; right: 0; top: 30px; background: #fff; padding: 1px; z-index: 1; } helpfind-shop .select-child { box-sizing: border-box; width: 50%; height: 100%; float: left; padding: 5px; } helpfind-shop .select-child > .body { width: 100%; height: 160px; border: 1px solid #ddd; overflow-y: auto; } helpfind-shop .option { width: 95%; height: 30px; cursor: pointer; line-height: 30px; padding-left: 5%; } helpfind-shop .option:hover { background-color: #ddd; } helpfind-shop label { width: 30px; height: 30px; position: absolute; right: 0; top: 0; background: #fff; line-height: 30px; color: #d00; text-align: right; padding-right: 10px; }', function(opts) {
    var that = this;
    this.showselect = false;
    that.exDataShop = $.cookie("shopId");
    if (that.exDataShop) {
        that.showvalue = that.parent.parent.opts.shopname;
    } else {
        that.showvalue = '请选择所在城市的店铺(必填)';
    }
    that.update();
    this.value.onclick = function () {
        if (that['imDataCity']) {
            that.showselect = true;
            that.update();
        } else {
            $.getJSON('/json/shopCity.json', {
                siteId: $.cookie("siteId")
            }, function(json, textStatus) {
                if (json.code == 0) {
                    that['imDataCity'] = json.item;
                }
                that.showselect = true;
                that.update();
            });
        };
    }
    this.selectbg.onclick = function () {
        that.exDataShop = "";
        that.showvalue = '请选择所在城市的店铺(必填)';
        that.showselect = false;
        that.update();
    }
    this.doSelectCity = function(e) {
        that.city = e.target.dataset.city;
        that.imDataShop = that['imDataCity'][that.city];
        this.showvalue = that.city + '-';
        that.update();
    }.bind(this);
    this.doSelectShop = function(e) {
        that.exDataShop = e.target.dataset.code;
        this.showvalue = that.city + '-' + e.target.dataset.shop;
        this.showselect = false;
        that.update();
    }.bind(this);
    
});
riot.tag('helpfind-submit', '<button id="submit" class="submit">提交</button>', 'helpfind-submit { display: block; width: 100%; height: 30px; } helpfind-submit .submit { display: block; width: 150px; height: 40px; background-color: #0F448E; font-size: 16px; color: #FFF; border: medium none; cursor: pointer; border-radius: 5px; }', function(opts) {
    var that = this;
    this.submit.style.backgroundColor = this.parent.parent.opts.bgcolor;
    this.submit.onclick = function () {
        var phoneReg = /^1[0-9]{10}$/;
        var phoneNum = that.parent.tags['helpfind-cellphone'].getvalue();
        if (!phoneReg.test(phoneNum)) {
            riot.route('alert/请输入正确的手机号码');
        } else if ($.cookie("crmUserId")) {
            doSubmit();
        } else {
            doLogin();
        }
    }
    function doSubmit () {
        if (!that.parent.tags['helpfind-shop'].exDataShop) {
            alert('请选择所在城市的店铺');
            return false;
        }
        $.ajax({
            url: '/json/findCar.json',
            type: 'GET',
            dataType: 'json',
            data: {
                brand: that.parent.tags['helpfind-carmodel'].exDataBrand,
                series: that.parent.tags['helpfind-carmodel'].exDataSeries,
                mileage: that.parent.tags['helpfind-yearandmileage'].getyear(),
                year: that.parent.tags['helpfind-yearandmileage'].getmileage(),
                priceMin: that.parent.tags['helpfind-price'].getPriceMin(),
                priceMax: that.parent.tags['helpfind-price'].getPriceMax(),
                cellphone: that.parent.tags['helpfind-cellphone'].getvalue(),
                description: that.parent.tags['helpfind-description'].getvalue(),
                siteId: that.parent.tags['helpfind-shop'].exDataShop,
                crmUserId: $.cookie("crmUserId"),
                shopId: $.cookie("shopId"),
                platform: 'PLATFORM_WEB'
            },
        })
        .done(function() {
            riot.route('helpfindsubmitok');
        })
        .fail(function() {
            console.log("error");
        })
        .always(function() {
            console.log("complete");
        });
    }
    function doLogin () {
        $.ajax({
            url: 'json/login.json',
            type: 'GET',
            dataType: 'json',
            data: {
                phone: that.parent.tags['helpfind-cellphone'].getvalue()
            },
        })
        .done(function() {
            doSubmit();
        })
        .fail(function() {
            console.log("error");
        })
        .always(function() {
            console.log("complete");
        });
    }
    
});
riot.tag('helpfind-cellphone', '<input type="text" name="{ name }" id="{ name }" placeholder="手机号码（必填）" value="{ parent.parent.opts.logined }"> <label for="{ name }">*</label>', 'helpfind-cellphone { display: block; width: 310px; height: 32px; border: solid #ddd 1px; position: relative; box-sizing: border-box; } helpfind-cellphone input { width: 296px; height: 28px; border: none; color: #666; padding-left: 10px; font-size: 12px; } helpfind-cellphone label { width: 30px; height: 30px; position: absolute; right: 0; top: 0; background: #fff; line-height: 30px; color: #d00; text-align: right; padding-right: 10px; }', function(opts) {
    var that = this;
    this.name = 'input' + Math.random();
    this.getvalue = function () {
        return that['{ name }'].value;
    }
    
});
riot.tag('helpfind-description', '<input type="text" name="{ name }" id="{ name }" placeholder="其他描述"> <label for="{ name }"></label>', 'helpfind-description { display: block; width: 310px; height: 32px; border: solid #ddd 1px; position: relative; box-sizing: border-box; } helpfind-description input { width: 296px; height: 28px; border: none; color: #999; padding-left: 10px; font-size: 12px; } helpfind-description label { width: 30px; height: 30px; position: absolute; right: 0; top: 0; background: #fff; line-height: 30px; text-align: right; padding-right: 10px; }', function(opts) {
    var that = this;
    this.name = 'input' + Math.random();
    this.getvalue = function () {
        return that['{ name }'].value;
    }
    
});
riot.tag('helpfind-yearandmileage', '<helpfind-year class="fl"></helpfind-year> <div class="c"></div> <helpfind-mileage class="fr"></helpfind-mileage>', 'helpfind-yearandmileage { position: relative; display: block; height: 32px; } helpfind-yearandmileage .fl { position: absolute; left: 0; top: 0; } helpfind-yearandmileage .fr { position: absolute; right: 0; top: 0; } helpfind-yearandmileage .c { width: 100%; height: 100%; text-align: center; color: #999; line-height: 30px; }', function(opts) {
    var that = this;
    this.getyear = function () {
        return that.tags['helpfind-year'].exDataYear;
    }
    this.getmileage = function () {
        return that.tags['helpfind-mileage'].exDataMileage;
    }
    
});
riot.tag('helpfind-mileage', '<div class="value" id="value"> { showvalue } </div> <div class="selectbg" if="{ showselect }" id="selectbg"></div> <div class="select" if="{ showselect }"> <div class="year select-child"> <div class="title">请选择里程</div> <div class="body"> <div class="option" each="{ val, i in year }" onclick="{ parent.doSelectYear }" data-code="{ i + 1 }" data-name="{ val }">{ val }</div> </div> </div> </div>', 'helpfind-mileage { display: block; width: 148px; height: 30px; border: solid #ddd 1px; position: relative; } helpfind-mileage .value { width: 100%; height: 100%; line-height: 30px; cursor: pointer; color: #999; padding-left: 10px; font-size: 12px; } helpfind-mileage .selectbg { position: fixed; width: 100%; height: 100%; top: 0; left: 0; background: rgba(0,0,0,0.1); } helpfind-mileage .select { box-sizing: border-box; width: 100%; height: 200px; border: #FF5517 solid 2px; position: absolute; right: 0; top: 30px; background: #fff; padding: 1px; z-index: 1; } helpfind-mileage .select-child { box-sizing: border-box; width: 100%; height: 100%; float: left; padding: 5px; } helpfind-mileage .select-child > .body { width: 100%; height: 160px; border: 1px solid #ddd; overflow-y: auto; } helpfind-mileage .option { width: 95%; height: 30px; cursor: pointer; line-height: 30px; padding-left: 5%; font-size: 12px; } helpfind-mileage .option:hover { background-color: #ddd; }', function(opts) {
    var that = this;
    this.showselect = false;
    this.showvalue = '里程';
    this.value.onclick = function () {
        that.year = [1, 3, 6, 10];
        for (var i = that.year.length - 1; i >= 0; i--) {
            that.year[i] = that.year[i] + '万公里内';
        };
        that.year.push('大于10万公里');

        that.showselect = true;
        that.update();
    }
    this.selectbg.onclick = function () {
        that.showselect = false;
        that.update();
    }
    this.doSelectYear = function(e) {
        that.exDataMileage = e.target.dataset.code;
        this.showvalue = e.target.dataset.name;
        this.showselect = false;
        that.update();
    }.bind(this);
    
});
riot.tag('helpfind-year', '<div class="value" id="value"> { showvalue } </div> <div class="selectbg" if="{ showselect }" id="selectbg"></div> <div class="select" if="{ showselect }"> <div class="year select-child"> <div class="title">请选择年限</div> <div class="body"> <div class="option" each="{ val, i in year }" onclick="{ parent.doSelectYear }" data-code="{ i + 1 }" data-name="{ val }" >{ val }</div> </div> </div> </div>', 'helpfind-year { display: block; width: 148px; height: 30px; border: solid #ddd 1px; position: relative; } helpfind-year .value { width: 300px; height: 100%; line-height: 30px; cursor: pointer; color: #999; padding-left: 10px; font-size: 12px; } helpfind-year .selectbg { position: fixed; width: 100%; height: 100%; top: 0; left: 0; background: rgba(0,0,0,0.1); } helpfind-year .select { box-sizing: border-box; width: 100%; height: 200px; border: #FF5517 solid 2px; position: absolute; right: 0; top: 30px; background: #fff; padding: 1px; z-index: 1; } helpfind-year .select-child { box-sizing: border-box; width: 100%; height: 100%; float: left; padding: 5px; } helpfind-year .select-child > .body { width: 100%; height: 160px; border: 1px solid #ddd; overflow-y: auto; } helpfind-year .option { width: 95%; height: 30px; cursor: pointer; line-height: 30px; padding-left: 5%; font-size: 12px; } helpfind-year .option:hover { background-color: #ddd; }', function(opts) {
    var that = this;
    this.showselect = false;
    this.showvalue = '年限';
    this.value.onclick = function () {
        that.year = [1, 2, 3, 5, 8, 10];
        for (var i = that.year.length - 1; i >= 0; i--) {
            that.year[i] = that.year[i] + '年内';
        };
        that.year.push('大于10年');

        that.showselect = true;
        that.update();
    }
    this.selectbg.onclick = function () {
        that.showselect = false;
        that.update();
    }
    this.doSelectYear = function(e) {
        that.exDataYear = e.target.dataset.code;
        this.showvalue = e.target.dataset.name;
        this.showselect = false;
        that.update();
    }.bind(this);
    
});
riot.tag('helpfind-price', '<helpfind-pricemin class="fl"></helpfind-pricemin> <div class="c">-</div> <helpfind-pricemax class="fr"></helpfind-pricemax>', 'helpfind-price { position: relative; display: block; height: 32px; } helpfind-price .fl { position: absolute; left: 0; top: 0; } helpfind-price .fr { position: absolute; right: 0; top: 0; } helpfind-price .c { width: 100%; height: 30px; line-height: 30px; text-align: center; color: #999; }', function(opts) {
    var that = this;
    this.getPriceMin = function () {
        return that.tags['helpfind-pricemin'].getvalue();
    }
    this.getPriceMax = function () {
        return that.tags['helpfind-pricemax'].getvalue();
    }
    
});
riot.tag('helpfind-pricemin', '<input riot-type={"number"} name="{ name }" id="{ name }" > <label for="{ name }">万元</label>', 'helpfind-pricemin { display: block; width: 148px; height: 30px; border: solid #ddd 1px; position: relative; box-sizing: content-box; } helpfind-pricemin input { width: 137px; height: 28px; border: none; color: #999; padding-left: 10px; font-size: 12px; } helpfind-pricemin label { width: 30px; height: 30px; position: absolute; right: 0; top: 0; background: #fff; line-height: 30px; text-align: right; padding-right: 10px; font-size: 12px; color: #999; }', function(opts) {
    var that = this;
    this.name = 'input' + Math.random();
    this.getvalue = function () {
        return that['{ name }'].value;
    }
    
});
riot.tag('helpfind-pricemax', '<input riot-type={"number"} name="{ name }" id="{ name }" > <label for="{ name }">万元</label>', 'helpfind-pricemax { display: block; width: 148px; height: 30px; border: solid #ddd 1px; position: relative; } helpfind-pricemax input { width: 137px; height: 28px; border: none; color: #999; padding-left: 10px; font-size: 12px; } helpfind-pricemax label { width: 30px; height: 30px; position: absolute; right: 0; top: 0; background: #fff; line-height: 30px; text-align: right; padding-right: 10px; font-size: 12px; color: #999; }', function(opts) {
    var that = this;
    this.name = 'input' + Math.random();
    this.getvalue = function () {
        return that['{ name }'].value;
    }
    
});
riot.tag('helpfind-carmodel', '<div class="value" id="value"> { showvalue } </div> <div class="selectbg" if="{ showselect }" id="selectbg"></div> <div class="select" if="{ showselect }"> <div class="brand select-child"> <div class="title">请选择品牌</div> <div class="body"> <div class="option" each="{ imDataBrand }" onclick="{ parent.doSelectBrand }" data-code="{ code }" data-name="{ name }">{ name }</div> </div> </div> <div class="series select-child"> <div class="title">请选择车系</div> <div class="body" if="{ exDataBrand }"> <div class="optgroup" each="{ name, value in imDataSeries }"> <div class="optgrouplabel">{ name }</div> <div class="option" each="{ value }" onclick="{ parent.parent.doSelectSeries }" data-code="{ code }" data-name="{ name }">{ name }</div> </div> </div> <div class="body" if="{ !exDataBrand }"> <div class="option">请先选择品牌</div> </div> </div> </div>', 'helpfind-carmodel { display: block; width: 100%; height: 32px; border: solid #ddd 1px; position: relative; box-sizing: border-box; } helpfind-carmodel .value { width: 300px; height: 100%; line-height: 30px; cursor: pointer; color: #999; padding-left: 10px; font-size: 12px; } helpfind-carmodel .selectbg { position: fixed; width: 100%; height: 100%; top: 0; left: 0; background: rgba(0,0,0,0.1); } helpfind-carmodel .select { box-sizing: border-box; width: 100%; height: 200px; border: #FF5517 solid 2px; position: absolute; right: 0; top: 30px; background: #fff; padding: 1px; z-index: 1; } helpfind-carmodel .select-child { box-sizing: border-box; width: 50%; height: 100%; float: left; padding: 5px; } helpfind-carmodel .select-child > .body { width: 100%; height: 160px; border: 1px solid #ddd; overflow-y: auto; } helpfind-carmodel .optgrouplabel { background: #999; color: #fff; font-size: 12px; } helpfind-carmodel .option { width: 95%; height: 30px; cursor: pointer; line-height: 30px; padding-left: 5%; font-size: 12px; } helpfind-carmodel .option:hover { background-color: #ddd; }', function(opts) {
    var that = this;
    this.showselect = false;
    that.showvalue = '选择车型';
    this.value.onclick = function (e) {
        if (that['imDataBrand']) {
            that.showselect = true;
            that.update();
        } else {
            $.getJSON('/json/dict/loadRootLevel.json', {
                type: 'car-subdivision'
            }, function(json, textStatus) {
                if (json.code == 0) {
                    that['imDataBrand'] = json.data;
                }
                that.showselect = true;
                that.update();
            });
        };
    }
    this.selectbg.onclick = function () {
        that.showselect = false;
        that.update();
    }
    this.doSelectBrand = function(e) {
        that.exDataBrand = e.target.dataset.code;
        that.showvalue = e.target.dataset.name;
        $.getJSON('/json/dict/loadRootLevelForCar.json', {
            type: 'car-subdivision',
            code: that.exDataBrand
        }, function (json, textStatus) {
            if (json.code == 0) {
                that['imDataSeries'] = json.data.codes;
            }
            that.update();
        })
    }.bind(this);
    this.doSelectSeries = function(e) {
        that.exDataSeries = e.target.dataset.code;
        that.showvalue = e.target.dataset.name;
        that.showselect = false;
        that.update();
    }.bind(this);
    
});
//- <script> 
riot.mount('pc-helpfind');



// WEBPACK FOOTER //
// ./src/modules/helpfind/riot/Diana.js